export interface HeroSlide {
  filmId: string;
  kicker: string;
  backdrop: string;
}

export const heroSlides: HeroSlide[] = [
  {
    filmId: "f001",
    kicker: "编辑精选 · 年度剧情",
    backdrop: "https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20landscape%20of%20a%20vast%20golden%20desert%20at%20sunset%20with%20distant%20rugged%20mountains%2C%20a%20tiny%20lone%20traveler%20silhouette%20walking%20toward%20the%20horizon%2C%20warm%20amber%20and%20deep%20orange%20sky%2C%20long%20shadows%20and%20floating%20dust%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%20film%20still&width=1920&height=1080&seq=hero-slide-01&orientation=landscape",
  },
  {
    filmId: "f012",
    kicker: "热映推荐 · 深海科幻",
    backdrop: "https://readdy.ai/api/search-image?query=Deep%20ocean%20abyss%20cinematic%20wide%20shot%20with%20a%20single%20warm%20amber%20light%20beam%20cutting%20through%20dark%20water%2C%20a%20tiny%20submersible%20descending%20into%20the%20trench%2C%20vast%20suspended%20particles%2C%20deep%20teal%20and%20orange%20contrast%2C%20tense%20awe%20inspiring%20atmosphere%2C%20high%20detail%20film%20still&width=1920&height=1080&seq=hero-slide-02&orientation=landscape",
  },
  {
    filmId: "f007",
    kicker: "高分口碑 · 历史群像",
    backdrop: "https://readdy.ai/api/search-image?query=Grand%20historical%20Chinese%20city%20panorama%20at%20golden%20sunset%20with%20ink%20wash%20mountains%20in%20the%20distance%2C%20ancient%20rooftops%20and%20a%20solemn%20orange%20sky%2C%20mist%20over%20the%20valley%2C%20epic%20solemn%20cinematic%20mood%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20high%20detail%20film%20still&width=1920&height=1080&seq=hero-slide-03&orientation=landscape",
  },
];